﻿window.mapForPlaceGoogleMaps = null
window.servicePlaceGoogleMaps = null
//var positionUser = null

//function mGetPositionUser(funcOk) {
//    if (positionUser == null) {
//        if (navigator.geolocation) {
//            var geoOpt = {
//                timeout: 3000,
//                maximumAge: 30
//            }
//            navigator.geolocation.getCurrentPosition(geoSucc, geoErr, geoOpt);

//            function geoSucc(position) {
//                positionUser = {
//                    latitude: position.coords.latitude,
//                    longitude: position.coords.longitude
//                }
//                if (typeof funcOk != 'undefined') funcOk()
//            }
//            function geoErr(error) {
//                positionUser = {
//                    latitude: 48.862221692783834,
//                    longitude: 2.349436690484968
//                }
//                if (typeof funcOk != 'undefined') funcOk()
//                //switch (error.code) {
//                //    case error.PERMISSION_DENIED:
//                //        $("#demo").html('User denied the request for Geolocation.');
//                //        break;
//                //    case error.POSITION_UNAVAILABLE:
//                //        $("#demo").html('Location information is unavailable.');
//                //        break;
//                //    case error.TIMEOUT:
//                //        $("#demo").html('The request to get user location timed out.');
//                //        break;
//                //    case error.UNKNOWN_ERROR:
//                //        $("#demo").html('An unknown error occurred.');
//                //        break;
//                //}
//            }
//        }
//    }
//    return positionUser
//}

window.cGoogleMapsApi = function (bddRef) {
    var Me = this;
    this.mGetLstAdressFromString = function (textSearch, funcOk) {
        console.log("recherche adresse : " + textSearch)
        var positionUser = {
            latitude: 48.862221692783834,
            longitude: 2.349436690484968
        }
        if (bddRef.positionUser != null) {
            positionUser = {
                latitude: bddRef.positionUser.latitude,
                longitude: bddRef.positionUser.longitude
            }
        }
        return bddRef.mAjaxCall({
            command: "getadressegooglemaps",
            text_search: textSearch,
            latitude_source: positionUser.latitude,
            longitude_source: positionUser.longitude
        }, function (data) {
            var lstResult = []
            if (typeof data.adresses != 'undefined') {
                lstResult = data.adresses
            }
            funcOk(lstResult)
        })
    }

    this.mGetAdresseDetail = function (prediction, funcOk) {
        if (!mapForPlaceGoogleMaps) mapForPlaceGoogleMaps = new google.maps.Map($("<div/>")[0]);
        if (!servicePlaceGoogleMaps) servicePlaceGoogleMaps = new google.maps.places.PlacesService(mapForPlaceGoogleMaps)
        servicePlaceGoogleMaps.getDetails({
            placeId: prediction.id
        }, function (place, status) {
            if (status == "OK") {
                var adresseDetail = {
                    ad1: "",
                    cp: "",
                    ville: "",
                    dpt: "",
                    region: "",
                    pays: "",
                    code_pays: "",
                    latitude: null,
                    longitude: null
                }
                var streetNumber = place.address_components.filter(function (o) { return o.types.contains("street_number") })[0]
                var route = place.address_components.filter(function (o) { return o.types.contains("route") })[0]
                var ville = place.address_components.filter(function (o) { return o.types.contains("locality") })[0]
                var dpt = place.address_components.filter(function (o) { return o.types.contains("administrative_area_level_2") })[0]
                var region = place.address_components.filter(function (o) { return o.types.contains("administrative_area_level_1") })[0]
                var pays = place.address_components.filter(function (o) { return o.types.contains("country") })[0]
                var cp = place.address_components.filter(function (o) { return o.types.contains("postal_code") })[0]
                var libelle = place.formatted_address

                adresseDetail.ad1 = ((typeof streetNumber == 'undefined') ? "" : streetNumber.long_name) + " " + ((typeof route == 'undefined') ? "" : route.short_name)
                if (majAd1Ad2) {
                    adresseDetail.ad2 = null
                    adresseDetail.ad3 = null
                }
                adresseDetail.cp = ((typeof cp == "undefined") ? null : cp.long_name)
                adresseDetail.ville = ((typeof ville == "undefined") ? null : ville.long_name)
                adresseDetail.cedex = null
                adresseDetail.dpt = ((typeof dpt == "undefined") ? null : dpt.long_name)
                adresseDetail.region = ((typeof region == "undefined") ? null : region.long_name)
                adresseDetail.pays = ((typeof pays == "undefined") ? null : pays.long_name)
                adresseDetail.code_pays = ((typeof pays == "undefined") ? null : pays.short_name)
                adresseDetail.latitude = place.geometry.location.lat()
                adresseDetail.longitude = place.geometry.location.lng()

                funcOk(adresseDetail)

            } else {
                funcOk(null)
            }

        })
    }

    //this.mInitAdresseWithPlace = function (placeId, champ_table_data_adresse, uniquementGeocode, majAd1Ad2, funcOk) {
    //    if (!mapForPlaceGoogleMaps) mapForPlaceGoogleMaps = new google.maps.Map($("<div/>")[0]);
    //    if (!servicePlaceGoogleMaps) servicePlaceGoogleMaps = new google.maps.places.PlacesService(mapForPlaceGoogleMaps)
    //    servicePlaceGoogleMaps.getDetails({
    //        placeId: placeId
    //    }, function (place, status) {
    //        if (status == "OK") {
    //            var streetNumber = place.address_components.filter(function (o) { return o.types.contains("street_number") })[0]
    //            var route = place.address_components.filter(function (o) { return o.types.contains("route") })[0]
    //            var ville = place.address_components.filter(function (o) { return o.types.contains("locality") })[0]
    //            var dpt = place.address_components.filter(function (o) { return o.types.contains("administrative_area_level_2") })[0]
    //            var region = place.address_components.filter(function (o) { return o.types.contains("administrative_area_level_1") })[0]
    //            var pays = place.address_components.filter(function (o) { return o.types.contains("country") })[0]
    //            var cp = place.address_components.filter(function (o) { return o.types.contains("postal_code") })[0]
    //            var libelle = place.formatted_address

    //            if (!uniquementGeocode) {
    //                champ_table_data_adresse.ad1 = ((typeof streetNumber == 'undefined') ? "" : streetNumber.long_name) + " " + ((typeof route == 'undefined') ? "" : route.short_name)
    //                if (majAd1Ad2) {
    //                    champ_table_data_adresse.ad2 = null
    //                    champ_table_data_adresse.ad3 = null
    //                }
    //                champ_table_data_adresse.cp = ((typeof cp == "undefined") ? null : cp.long_name)
    //                champ_table_data_adresse.ville = ((typeof ville == "undefined") ? null : ville.long_name)
    //                champ_table_data_adresse.cedex = null
    //                champ_table_data_adresse.dpt = ((typeof dpt == "undefined") ? null : dpt.long_name)
    //                champ_table_data_adresse.region = ((typeof region == "undefined") ? null : region.long_name)
    //                champ_table_data_adresse.pays = ((typeof pays == "undefined") ? null : pays.long_name)
    //                champ_table_data_adresse.code_pays = ((typeof pays == "undefined") ? null : pays.short_name)
    //            }
    //            champ_table_data_adresse.geo_latitude = place.geometry.location.lat()
    //            champ_table_data_adresse.geo_longitude = place.geometry.location.lng()
    //            champ_table_data_adresse.normalise = 1

    //            if (typeof champ_table_data_adresse.id == 'undefined' || champ_table_data_adresse.id == null) {
    //                //L'id n'est pas défini, on est sur la création d'un élément
    //            } else {
    //                var obj = bdd.getObjet(champ_table_data_adresse)
    //                obj.mSave()
    //            }

    //            if (typeof funcOk != 'undefined') funcOk()

    //        } else {
    //            mNotify("Impossible d'utiliser cette adresse.", "error", 6000)
    //        }

    //    })
    //}


    this.mGetJson = function (searchString, funcOK) {

    }
}

window.cGoogleBusinessApi = function (bddRef) {

    this.mGetLstPlaceFromString = function (textSearch, nb, funcOk) {
        bddRef.mAjaxCall({ command: "getresultsearchapigoogle", searchstring: textSearch, nb: nb }, function (data) {
            if (typeof data.googleplace == 'undefined' || data.googleplace.length == 0) {
                funcOk()
            } else {
                funcOk(data.googleplace[0])
            }
        })
    }

}